export default "__VITE_ASSET__3683522b__"